/**
 * Normalise Malaysia phone numbers to E.164 form "+60XXXXXXXXX".
 * Accepts common local forms: "012-345 6789", "0123456789", "60123456789", "+60 12 345 6789".
 */
export function normalizeMyPhone(input) {
    const digits = input.replace(/[^\d]/g, "");
    if (!digits)
        return null;
    // Already +60 form (without the plus). Lower bound is 9, not 11: a
    // 7-8 digit local subscriber number prefixed with "60" (e.g. "6010023707",
    // from input "+6010023707") is already normalized and must be matched here
    // before the bare-mobile branch below, which would otherwise treat its
    // leading "60" as a mobile prefix and double-prefix it.
    if (digits.startsWith("60") && digits.length >= 9 && digits.length <= 13) {
        return `+${digits}`;
    }
    // Local form starting with 0, e.g. 0123456789
    if (digits.startsWith("0") && digits.length >= 10 && digits.length <= 11) {
        return `+60${digits.slice(1)}`;
    }
    // Bare 9-10 digit mobile number (no leading 0). Malaysian mobile prefixes
    // are 01X, so a legitimate bare number here never starts with "60" -
    // those are caught by the already-+60 branch above instead.
    if (digits.length >= 9 && digits.length <= 10 && !digits.startsWith("0")) {
        return `+60${digits}`;
    }
    return null;
}
export function isMyPhone(input) {
    return /^\+60\d{9,11}$/.test(input);
}
//# sourceMappingURL=phone.js.map